import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthResourceUrl } from 'utils/auth-resource-url';
import { isPreviewSupported } from 'utils/file';
import { MimeTypes } from 'utils/mime-types';
import { appendParams } from 'utils/url';
export const Resource = ({ fileObject, }) => {
    const { t } = useTranslation('object', {
        keyPrefix: 'cmp.FileObjectPreview',
    });
    const { name, mimeType, downloadUrl } = fileObject;
    const previewSupported = isPreviewSupported(mimeType);
    const { error, loading, url } = useAuthResourceUrl(appendParams(downloadUrl, { download: 'false' }), previewSupported);
    if (!previewSupported) {
        return null;
    }
    if (loading) {
        return _jsx(CircularProgress, { "data-testid": "PreviewLoading" });
    }
    if (error || !url) {
        return _jsx(Typography, { children: t('previewLoadFailed') });
    }
    if (isPreviewSupported(mimeType, 'image')) {
        return (_jsx("img", { src: url, alt: name, style: { height: '100%', objectFit: 'scale-down', width: '100%' } }));
    }
    if (isPreviewSupported(mimeType, 'object')) {
        return (_jsx("object", { width: "100%", height: "100%", data: url, type: MimeTypes.PDF, role: "document", children: t('noPdfViewerInstalled') }));
    }
    if (isPreviewSupported(mimeType, 'video')) {
        return (_jsx("video", { controls: true, preload: "metadata", src: url, style: {
                maxHeight: '100%',
                maxWidth: '100%',
            }, "data-testid": "VideoPreview" }));
    }
    if (isPreviewSupported(mimeType, 'audio')) {
        return (_jsx("audio", { controls: true, preload: "metadata", src: url, "data-testid": "AudioPreview" }));
    }
    if (isPreviewSupported(mimeType, 'text')) {
        return (_jsx("iframe", { width: "100%", height: "100%", sandbox: "", src: url, title: name }));
    }
    return null;
};
